/* globals replaceURL */
import { deprecatedParseGoogleLocationApiDetails } from 'GlobalShared/utilities/googleGeocoder'
;(function () {
  function propertySearchService(
    $rootScope,
    $timeout,
    propertiesService,
    trackPermitMapService,
    locationService
  ) {
    var budgetOptions = [
      { id: 1, name: 'Any Budget' },
      { id: 2, name: 'Less than $1k', job_value_max: '1000' },
      {
        id: 3,
        name: '$1k to $5k',
        job_value_min: '1000',
        job_value_max: '5000',
      },
      {
        id: 4,
        name: '$5k to $20k',
        job_value_min: '5000',
        job_value_max: '20000',
      },
      {
        id: 5,
        name: '$20k to $50k',
        job_value_min: '20000',
        job_value_max: '50000',
      },
      {
        id: 6,
        name: '$50k to $100k',
        job_value_min: '50000',
        job_value_max: '100000',
      },
      {
        id: 6,
        name: '$50k to $100k',
        job_value_min: '50000',
        job_value_max: '100000',
      },
      {
        id: 6,
        name: '$100k to $250k',
        job_value_min: '100000',
        job_value_max: '250000',
      },
      {
        id: 6,
        name: '$250k to $500k',
        job_value_min: '250000',
        job_value_max: '500000',
      },
      {
        id: 6,
        name: '$500k to $1m',
        job_value_min: '500000',
        job_value_max: '1000000',
      },
      { id: 7, name: 'More than $1m', job_value_min: '1000000' },
    ]
    // backend date_format "2014-07-29"
    var currentYear = new Date().getFullYear()
    var dateOptions = [{ id: 1, name: 'All Years' }]
    for (var year = currentYear; year >= 2010; year--) {
      dateOptions.push({
        id: year,
        name: 'Since ' + year,
        date_from: year + '-01-01',
      })
    }
    //ids are from project_types table
    var permitAttributeOptions = [
      { name: 'All Projects' },
      { name: 'New Construction', id: 1, type: 'PropertyTypeGroup' },
      { name: 'Home Addition', id: 2, type: 'PropertyTypeGroup' },
      { name: 'Commercial Renovation', id: 4, type: 'PropertyTypeGroup' },
      { name: 'Multi-Room Remodel', id: 10, type: 'ProjectType' },
      { name: 'Kitchen Remodel', id: 11, type: 'ProjectType' },
      { name: 'Basement Remodel', id: 13, type: 'ProjectType' },
      { name: 'ADU', id: 119, type: 'ProjectType' },
      { name: 'Garage Construction', id: 73, type: 'ProjectType' },
      { name: 'Electrical Work', id: 26, type: 'ProjectType' },
      { name: 'Plumbing', id: 89, type: 'ProjectType' },
      { name: 'HVAC', id: 35, type: 'ProjectType' },
      { name: 'Roofing', id: 21, type: 'ProjectType' },
      { name: 'Solar Installation', id: 27, type: 'ProjectType' },
      { name: 'Pool and Spa Construction', id: 56, type: 'ProjectType' },
      { name: 'Demolition', id: 60, type: 'ProjectType' },
      { name: 'Sewer Laterals', id: 61, type: 'ProjectType' },
      { name: 'Decks and Porches', id: 37, type: 'ProjectType' },
      { name: 'Flatwork Concrete', id: 53, type: 'ProjectType' },
      { name: 'Siding', id: 32, type: 'ProjectType' },
      { name: 'Signage', id: 82, type: 'ProjectType' },
      { name: 'Foundations', id: 54, type: 'ProjectType' },
      { name: 'Mechanical Work', id: 106, type: 'ProjectType' },
      { name: 'Paving, Driveways, and Sidewalks', id: 62, type: 'ProjectType' },
      { name: 'Landscape', id: 77, type: 'ProjectType' },
      { name: 'Doors and Windows', id: 38, type: 'ProjectType' },
      { name: 'Excavation and Grading', id: 64, type: 'ProjectType' },
      { name: 'Patios', id: 101, type: 'ProjectType' },
      { name: 'Docks', id: 103, type: 'ProjectType' },
      { name: 'Retaining Walls', id: 95, type: 'ProjectType' },
      { name: 'Mobile Homes', id: 105, type: 'ProjectType' },
      { name: 'Pole Barn', id: 107, type: 'ProjectType' },
      { name: 'Fences', id: 34, type: 'PropertyTypeGroup' },
    ]

    var setPermitAttributeParam = function () {
      propertiesService.setParam(
        'permit_attribute_id',
        propertySearchService.permitAttributeOption.id
      )
      propertiesService.setParam(
        'permit_attribute_type',
        propertySearchService.permitAttributeOption.type
      )
    }

    var setBudgetParam = function () {
      propertiesService.setParam(
        'job_value_min',
        propertySearchService.budgetOption.job_value_min
      )
      propertiesService.setParam(
        'job_value_max',
        propertySearchService.budgetOption.job_value_max
      )
    }

    var setDateParam = function () {
      propertiesService.setParam(
        'date_from',
        propertySearchService.dateOption.date_from
      )
    }

    var clearFilterParams = function () {
      propertiesService.resetParams([
        'permit_attributes',
        'job_value_min',
        'job_value_max',
        'date_from',
      ])
    }

    var changeCityStatePath = function (city, state) {
      var cityStatePath = location.pathname.split('/')[2]
      replaceURL(cityStatePath, locationService.to_slug(city + ', ' + state))
    }

    var setURLForValidAddress = function (match) {
      changeCityStatePath(match.city, match.state)
      resetFilters()
      propertiesService.setURLForExactAddress(match)
    }

    var setPermitAttributeOnLoad = function () {
      var permitAttributeId = getURLParameter('permit_attribute_id')
      var permitAttribute = {}
      if (permitAttributeId) {
        permitAttribute.id = parseInt(permitAttributeId)
        permitAttribute.type = getURLParameter('permit_attribute_type')
      }
      if (permitAttribute.id && permitAttribute.type) {
        for (var i = 0; i < permitAttributeOptions.length; i++) {
          if (permitAttributeOptions[i].id === permitAttribute.id) {
            propertySearchService.permitAttributeOption =
              permitAttributeOptions[i]
            return true
          }
        }
      }
      setDefaultPermitAttribute()
      return false
    }

    var setDateOnLoad = function () {
      var dateFrom = getURLParameter('date_from')
      if (dateFrom) {
        for (var i = 0; i < dateOptions.length; i++) {
          if (dateOptions[i].date_from === dateFrom) {
            propertySearchService.dateOption = dateOptions[i]
            return true
          }
        }
      }
      setDefaultDate()
      return false
    }

    var setBudgetOnLoad = function () {
      var minBudget = getURLParameter('job_value_min')
      var maxBudget = getURLParameter('job_value_max')
      if (minBudget || maxBudget) {
        for (var i = 0; i < budgetOptions.length; i++) {
          if (
            (minBudget && budgetOptions[i].job_value_min === minBudget) ||
            (maxBudget && budgetOptions[i].job_value_max === maxBudget)
          ) {
            propertySearchService.budgetOption = budgetOptions[i]
            return true
          }
        }
      }
      setDefaultBudget()
      return false
    }

    var setDefaults = function () {
      setDefaultBudget()
      setDefaultDate()
      setDefaultPermitAttribute()
    }

    var setDefaultBudget = function () {
      propertySearchService.budgetOption = budgetOptions[0]
    }

    var setDefaultDate = function () {
      propertySearchService.dateOption = dateOptions[0]
    }

    var setDefaultPermitAttribute = function () {
      propertySearchService.permitAttributeOption = permitAttributeOptions[0]
    }

    var error = function () {
      propertySearchService.bad_query = propertySearchService.query
      propertySearchService.error = true
      $rootScope.in_progress = false
      // hide message after timeout
      $timeout(function () {
        propertySearchService.error = false
      }, 4000)
    }

    var resetFilters = function () {
      propertySearchService.showResetFiltersLink = false
      propertySearchService.setDefaultOptions()
      clearFilterParams()
    }

    var search = function () {
      setPermitAttributeParam()
      setBudgetParam()
      setDateParam()
      propertySearchService.showResetFiltersLink = true

      $rootScope.$broadcast('permit_map.search')
    }

    var propertySearchService = {
      budgetOptions: budgetOptions,
      dateOptions: dateOptions,
      permitAttributeOptions: permitAttributeOptions,
      search: function () {
        search()
      },
      redoSearch: function () {
        propertySearchService.query = ''
        propertiesService.resetParams(['full_address'])
        propertiesService.removeCityPath()
        search()
      },
      resetFilters: function () {
        resetFilters()

        $rootScope.$broadcast('permit_map.search')
      },
      setDefaultOptions: function () {
        setDefaults()
        propertySearchService.allowRedoSearch = false
        propertySearchService.showResetFiltersLink = false
      },
      queryAddress: function (event) {
        if (propertySearchService.query === '') {
          propertySearchService.error = false
          return
        } else {
          propertySearchService.query =
            document.getElementById('permit-map-query').value
        }
        $rootScope.in_progress = true
        trackPermitMapService.submitAddress(
          propertySearchService.query,
          propertiesService.json_filters
        )
        propertiesService.geocode(propertySearchService.query).then(
          function (results) {
            if (results !== undefined && results[0] !== undefined) {
              propertySearchService.error = false
              //Google Maps API returns multiple possible matches; use first result
              let match = deprecatedParseGoogleLocationApiDetails(results)

              match.longitude = match.lng
              match.latitude = match.lat

              if (match.country !== 'United States') {
                error()
                return
              }
              propertySearchService.setAddress(match)
              if (propertySearchService.city) {
                propertySearchService.setURLForValidAddress(match)
                $rootScope.$broadcast(
                  'permitMapCtrl.queryAddress.success',
                  match
                )
              } else {
                error()
              }
            } else {
              error()
            }
          },
          function (reason) {
            error()
          }
        )
      },
      setURLForValidAddress: function (match) {
        setURLForValidAddress(match)
      },
      searched: function () {
        if (
          propertySearchService.latitude &&
          propertySearchService.longitude &&
          propertySearchService.query &&
          propertySearchService.formatted_address
        ) {
          return true
        } else {
          return false
        }
      },
      setAddress: function (address) {
        if (propertySearchService.city !== address.city) {
          propertySearchService.city = address.city
        }
        if (propertySearchService.state !== address.state) {
          propertySearchService.state = address.state
        }
        if (propertySearchService.latitude !== address.latitude) {
          propertySearchService.latitude = address.latitude
        }
        if (propertySearchService.longitude !== address.longitude) {
          propertySearchService.longitude = address.longitude
        }
        if (propertySearchService.street_number !== address.street_number) {
          propertySearchService.street_number = address.street_number
        }
        propertySearchService.formatted_address = address.formatted_address
        propertySearchService.query = propertySearchService.formatted_address
        // propertySearchService.query = [(address.street_address ? (address.street_address + ", ") : ""), (address.city ? (address.city + ", ") : ""), address.state].join("");
      },
      loadParams: function () {
        var permitAttributePresent = setPermitAttributeOnLoad()
        var budgetPresent = setBudgetOnLoad()
        var datePresent = setDateOnLoad()
        if (permitAttributePresent || budgetPresent || datePresent) {
          propertySearchService.showResetFiltersLink = true
        }
      },
    }
    propertySearchService.setDefaultOptions()
    return propertySearchService
  }

  bz_app.factory('propertySearchService', [
    '$rootScope',
    '$timeout',
    'propertiesService',
    'trackPermitMapService',
    'locationService',
    propertySearchService,
  ])
})()
